<a
  mat-menu-item
  class="hover:!text-primary"
  [i18nRouterLink]="link()"
  [i18nQueryParams]="params()"
  style="--mat-menu-item-label-text-size: 0.8rem"
>
  {{ text() }}
</a>
